import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import toLower from 'lodash/toLower';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { setLang } from '../../../services/App/actions';
import posterJA from '../../../assets/poster-ja.jpg';
import posterEN from '../../../assets/poster-en.jpg';

const Container = styled.div`
  background-color: #fa5956;
  @media (max-width: 991.98px) {
    width: 100vw;
  }
  @media (min-width: 992px) {
    height: 100vh;
  }
`;

const LangSwitch = styled.button`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 10000;
  border-radius: 0px !important;
  border: 1px solid #FFF !important;
`;

const Poster = styled.img`
  @media (max-width: 991.98px) {
    max-width: 100%;
    height: auto;
  }
  @media (min-width: 992px) {
    width: auto;
    height: 100%;
  }
`;

class Jumbotron extends Component {
  static propTypes = {
    Lang: PropTypes.string.isRequired,
    setLang: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  }

  onToggleLang = () => {
    const { setLang, Lang } = this.props;
    switch (Lang) {
      case 'en':
        setLang('ja');
        break;
      case 'ja':
        setLang('en');
        break;
      default: setLang('en');
    }
  }

  getNextLang = () => {
    const { Lang } = this.props;
    switch (Lang) {
      case 'en': return '日本語';
      case 'ja': return 'English';
      default: return 'N/A';
    }
  }

  getPoster = (lang) => {
    switch (toLower(lang)) {
      case 'en': return posterEN;
      case 'ja': return posterJA;
      default: return posterJA;
    }
  }

  render() {
    const { intl: { locale } } = this.props;

    return (
      <Fragment>
        <LangSwitch
          className="btn btn-sm btn-primary"
          onClick={this.onToggleLang}
        >
          {this.getNextLang()}
        </LangSwitch>
        <Container className="d-flex flex-column justify-content-center align-items-center">
          <Poster
            src={this.getPoster(locale)}
            alt="Oakhouse competition information poster"
          />
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  Lang: state.App.lang,
});

const mapDispatchToProps = {
  setLang,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Jumbotron));
